import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class LogHistoryService {
    static readonly $inject = ['BaseApiFactory'];
    constructor(private baseApiFactory: BaseApiFactory) {}

    GetAll(query: string, paging?: string): Promise<any> {
        return this.baseApiFactory.get(`/api/LogHistory?${query}&${paging}`);
    }
}

lazyRegister.service('LogHistoryService', LogHistoryService);
